import PropTypes from 'prop-types';
import { Icon } from '@evertrue/et-components';

const TemplateIndicator = ({ emailTemplate = {} }) => {
  const { templateName = '' } = emailTemplate;
  return (
    <div className="outreach-card-tab-group--item">
      <Icon icon="email-template" iconKit="gt2" size={1} />
      <span>: {templateName}</span>
    </div>
  );
};

TemplateIndicator.propTypes = {
  emailTemplate: PropTypes.object,
};

export default TemplateIndicator;
